/** ---- VISITOR CARDS ----
 * Visitor cards are intended to be a fairly self-contained directive that can be dropped anywhere to display records from the local database
 * or records that are, temporarily, held in memory.
 *
 * The bulk of Sentinel's data manipulation happens in this directive. Here, cards can be checked in, checked out, edited, and removed.
 */

function SentinelCards($interval, $rootScope, $location, sentinelService, filterService) {
    return {
        scope: {
            currentView: '=',
            hideControls: "=?",
            visits: '=',
            tableTitle: '='
        },
		template: require('./cards.html'),

        link: function(scope, elem, attrs) {
            scope.displayOptions = filterService.getTableDisplayOptions(scope.tableTitle);
            scope.masterDisplayOptions = filterService.getMasterDisplayOptions();
            scope.sortField = 'Check-In Time';
            scope.sortDirection = 'Desc.';
            scope.availableSortFields = ['Check-In Time', 'Check-Out Time', 'Company', 'Door In', 'Door Out', 'Escort In', 'Escort Out', 'Facility', 'Name (Last, First)', 'Reason', 'Visiting'];
            scope.availableSortDirections = ['Asc.', 'Desc.'];
            scope.userHasWrite = ($rootScope.selectedLog.role !== 'READ');
            scope.displayVisits = [];
            scope.loadingVisits = false;
            scope.requiredFields = {};
            scope.selectedFacility = "";

            // Note retrieval URL
            scope.gotoNoteURl = $location.$$protocol + ':%2F%2F' + $location.$$host + ':' + $location.$$port+ '%2Fapi%2Fnotes%2F';

            scope.toggleCommentPreview = function(noteId) {
                if(document.getElementById('comment-preview' + noteId).style.display === 'none') {
                    document.getElementById('comment-preview' + noteId).style.display = 'initial';
                } else {
                    document.getElementById('comment-preview' + noteId).style.display = 'none';
                }
            };

            scope.checkInVisitor = function (visit) {
                $rootScope.$broadcast('sentinel-show-check-in-modal', {visitorToCheckIn: visit});
            };

            scope.checkOutVisitor = function (visit) {
                $rootScope.$broadcast('sentinel-show-check-out-modal', {visitorToCheckOut: visit});
            };

            scope.undoCheckinVisitor = function (visit) {
                sentinelService.undoCheckinVisitor(visit);
            };

            scope.undoCheckoutVisitor = function (visit) {
                sentinelService.undoCheckoutVisitor(visit);
            };

            scope.editVisitor = function (visit) {
                $rootScope.$broadcast('sentinel-show-edit-modal', {visitorToEdit: visit});
            };

            scope.addComment = function (visit) {
                $rootScope.$broadcast('sentinel-show-comment-modal', {visitorToAddCommentTo: visit});
            };

            scope.removeVisitor = function (visit) {
                sentinelService.removeVisitor(visit);
            };

            scope.getRequiredFields = function() {
                sentinelService.getRequiredFields($rootScope.selectedLog.id, scope.selectedFacility).then(function (rf) {
                    scope.requiredFields = rf;
                });
            };

            scope.$on('selected-facility-changed', function(e, selectedFacility) {
                scope.selectedFacility = selectedFacility.selectedFacility;
                scope.getRequiredFields();
            });

            scope.isVis = function (name) {
                return (scope.requiredFields && scope.requiredFields[name] === "optional" || scope.requiredFields[name] === "required");
            };

            function applyFilters(newValue) {
                if (!(newValue instanceof Array)) {
                    return;
                }

                var tempVisits = [].concat(newValue),
                    activeVisits = filterService.filterActiveOnly(tempVisits);

                scope.activeVisitCount = activeVisits.length;
                tempVisits = scope.masterDisplayOptions.showActiveOnly || scope.displayOptions.showActiveOnly ? activeVisits : tempVisits;
                tempVisits = applySort(tempVisits);
                scope.displayVisits = sentinelService.generateUiData(tempVisits);
            }

            scope.toggleActiveOnly = function () {
                scope.displayOptions.showActiveOnly = !scope.displayOptions.showActiveOnly;
                filterService.setTableDisplayOptions(scope.tableTitle, scope.displayOptions);
                applyFilters(scope.visits);
            };

            scope.toggleComments = function () {
                scope.displayOptions.showComments = !scope.displayOptions.showComments;
                filterService.setTableDisplayOptions(scope.tableTitle, scope.displayOptions);
            };

            function applySort(visits) {
                var sortFieldValue,
                    sortDirectionValue;

                switch (scope.sortField) {
                    case 'Badge ID':
                        sortFieldValue = 'badgeId';
                        break;
                    case 'Check-In Time':
                        sortFieldValue = 'checkInTime';
                        break;
                    case 'Check-Out Time':
                        sortFieldValue = 'checkOutTime';
                        break;
                    case 'Company':
                        sortFieldValue = 'company';
                        break;
                    case 'Door In':
                        sortFieldValue = 'doorIn';
                        break;
                    case 'Door Out':
                        sortFieldValue = 'doorOut';
                        break;
                    case 'Escort In':
                        sortFieldValue = 'escortIn';
                        break;
                    case 'Escort Out':
                        sortFieldValue = 'escortOut';
                        break;
                    case 'Facility':
                        sortFieldValue = 'facilityName';
                        break;
                    case 'Name (Last, First)':
                        sortFieldValue = 'formattedName';
                        break;
                    case 'Reason':
                        sortFieldValue = 'reason';
                        break;
                    case 'Registration Time':
                        sortFieldValue = 'registrationTime';
                        break;
                    case 'Visiting':
                        sortFieldValue = 'visiting';
                        break;
                }

                switch (scope.sortDirection) {
                    case 'Asc.':
                        sortDirectionValue = 'asc';
                        break;
                    case 'Desc.':
                        sortDirectionValue = 'desc';
                        break;
                }

                return filterService.sortVisits(sortFieldValue, sortDirectionValue, visits);
            }

            scope.$on('selected-facility-changed', function(e, selectedFacility) {
                scope.selectedFacility = selectedFacility.selectedFacility;
                scope.getRequiredFields();
            });

            scope.$on('sentinel-update-start-search', function() {
                if (scope.currentView != "check-in") scope.loadingVisits = true;
            });

            scope.$on('sentinel-update-start-registered', function() {
                if (scope.currentView === "check-in") scope.loadingVisits = true;
            });

            scope.$on('sentinel-update-successful-search', function() {
                if (scope.currentView != "check-in") scope.loadingVisits = false;
            });

            scope.$on('sentinel-update-successful-registered', function() {
                if (scope.currentView === "check-in") scope.loadingVisits = false;
            });

            scope.$on('sentinel-update-failed', function() {
                scope.loadingVisits = false;
            });

            var headerSize = scope.currentView === 'visits' ? 340 : 270;
            var marginBtm = 15;
            var offset = 40;
            var heightCorrection = headerSize + marginBtm - offset;
            var visitorRowHeight = 131;

            $interval(function() {
                scope.tableStyle = {
                    "max-height": (window.innerHeight - heightCorrection) + "px"
                };
            }, 100);

            (function() {
                scope.$watch('masterDisplayOptions', function () {
                    applyFilters(scope.visits);
                    for (var i = 0; i < scope.availableSortFields.length; i++) {
                        if (scope.masterDisplayOptions.sortField === scope.availableSortFields[i].value) {
                            scope.sortDirection = scope.availableSortFields[i].displayName;
                        }
                    }
                    for (var i = 0; i < scope.availableSortDirections.length; i++) {
                        if (scope.masterDisplayOptions.sortDirection === scope.availableSortDirections[i].value) {
                            scope.sortField = scope.availableSortDirections[i].displayName;
                        }
                    }
                }, true);
                scope.$watch('displayOptions', function () {
                    applyFilters(scope.visits);
                    for (var i = 0; i < scope.availableSortFields.length; i++) {
                        if (scope.displayOptions.sortField === scope.availableSortFields[i].value) {
                            scope.sortDirection = scope.availableSortFields[i].displayName;
                        }
                    }
                    for (var i = 0; i < scope.availableSortDirections.length; i++) {
                        if (scope.displayOptions.sortDirection === scope.availableSortDirections[i].value) {
                            scope.sortField = scope.availableSortDirections[i].displayName;
                        }
                    }
                }, true);

                scope.$watchGroup(['visits', 'sortField', 'sortDirection'], function () {
                    applyFilters(scope.visits);
                });

            })();

            scope.selectedFacility = sentinelService.getSelectedFacility();
            scope.getRequiredFields();
        }};
}

angular.module('sentinel').directive('sentinelCards', ['$interval', '$rootScope', '$location', 'sentinelService', 'sentinelUiFilterService', SentinelCards]);